import { Http } from '@/lib/http';

export class DelinquencyActionsTaskAssignmentService extends Http {
  constructor() {
    super();
    this.endpoint =
      'delinquency-pro/settings/delinquency-control-action-tasks/';
  }

  /**
   * Retrieves the initial settings
   */
  getAssignments() {
    return this.httpClient().get(this.endpoint);
  }

  /**
   * Retrieves a paginated list of assignments.
   * @param {Object} params - The query parameters { page, limit, all }.
   */
  getPaginatedAssignments(params) {
    return this.httpClient().get(`${this.endpoint}paginated`, { params });
  }

  /**
   * Updates the assignment by ID
   *
   * @param {String} id - The ID of the assignment to update.
   * @param {Object} payload - The payload to update the settings.
   */
  updateAssignment(id, payload) {
    return this.httpClient().put(`${this.endpoint}${id}`, payload);
  }
}
